<template>
  <div id="how">
      <h3>How It Works</h3>
      <span>We try our best to make sure your service process is as simple as possible. &#128524;</span>

      <tabs>
      <tab title="For Customers" class="tab">
          <div class="custom">
              <div class="box1">
                  <h4>Make an Order</h4>
                  <img src="../assets/login.png" alt="customer first step">
                  <p>Download the app. Launch; select a meal; and complete your order.</p>
              </div>
              <div class="box2">
                  <Icons name="firstline" />
              </div>
              <div class="box3">
                  <Icons name="thirdline" class="line"/>
                  <div class="img">
                  <h4>Track Your Food</h4>
                  <img src="../assets/direct.png" alt="customer second step">
                  <p>You get to track your food through Packaging, Pick-up and Delivery.</p>
                  </div>
              </div>
              <div class="box4">
                  <h4>Recieve your food package</h4>
                  <div class="content">
                  <img src="../assets/covid.png" alt="customer third step">
                  <p>Your food gets delivered to you within few minutes of ordering. Right in time for you to feast.</p>
                  </div>
                  <Icons name="secondline" class="line"/>
              </div>
              <div class="box5">
                  <h4>Enjoy and Rate the service</h4>
                  <img src="../assets/eat.png" alt="customer last step">
                  <p>You can leave feedbacks on the restaurant and delivery services to help other users find them.</p>
              </div>
          </div>
      </tab>
      <tab title="For Vendors" class="tab">
         <div class="custom">
              <div class="box1">
                  <h4>Register your Restaurant</h4>
                  <img src="../assets/register.png" alt="customer first step">
                  <p>Download the app. Launch and register your restaurant.</p>
              </div>
              <div class="box2">
                  <Icons name="firstline" />
              </div>
              <div class="box3">
                  <Icons name="thirdline" class="line"/>
                  <div class="img">
                  <h4>Upload your Dishes</h4>
                  <img src="../assets/upload.png" alt="customer second step">
                  <p>Upload deatiled information of the meals you sell at  your restaurant.</p>
                  </div>
              </div>
              <div class="box4">
                  <h4>Take customer Orders</h4>
                  <div class="content">
                  <img src="../assets/order.png" alt="customer third step" class="box-img">
                  <p>You’ll recieve order notifications every time a customer order one or more of your dishes from the app.</p>
                  </div>
                  <Icons name="secondline" class="line"/>
              </div>
              <div class="box5">
                  <h4>Send Order and Get Paid</h4>
                  <img src="../assets/pay.png" alt="customer last step">
                  <p>Package the order and notify delivery agents to pick up.
After this, you’d recieve payments in your wallet.</p>
              </div>
          </div>
          </tab>
    </tabs>
    <a href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips" target="_blank"><button class="get">Get the App</button></a>
  </div>
</template>

<script>
import Tab from './Tab.vue'
import Tabs from './Tabs.vue'
import Icons from './Icons.vue'

export default {
    name: 'How',
    components: {
        Tab,
        Tabs,
        Icons
    }
}
</script>

<style lang="scss" scoped>
#how{
    background: #fff;
    height: 380vh;
    width: 100%;
    padding: 80px 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Raleway', sans-serif;
    a:hover{
        text-decoration: none;
    }
    h3{
        font-size: 36px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 24px;
        width: 466px;
        text-align: center;
        margin-bottom: 80px;
    }
    .tab{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 112px 0;
    }
    .custom{
        display: grid;    
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(5, 1fr);
        height: 250vh;
        width: 80%;
        h4{
            font-size: 32px;
            font-weight: 500;
            margin-bottom: 24px;
        }
        p{
            font-size: 24px;
            font-weight: 300;
            margin-top: 57px;
        }
    }
    .box1{
        grid-column: span 2;
        grid-row: span 2;
    }
    .box2{
        grid-column: span 2;
        grid-row: span 1;
    }
    .box3{
        display: flex;
        grid-column: span 2;
        grid-row: span 1;
        .line{
            align-self: flex-end;
            margin-right: 40px;
        }
        img{
            height: 276px;
        }
    }
    .box4{
        grid-column: span 2;
        grid-row: span 3;
        display: flex;
        flex-direction: column;
        .content{
            img{
                height: 276px;
                width: 372px;
            }
            .box-img{
                height: 276px;
                width: 239px;
            }
        }
        .line{
            align-self: flex-end;
        }
    }
    .box5{
        margin-top: 200px;
        margin-left: 150px;
        grid-column: span 2;
        grid-row: span 2;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}

@media (max-width: 480px) {
    #how{
    background: #fff;
    height: auto;
    width: 100%;
    padding: 80px 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Raleway', sans-serif;
    font-size: 16px;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .tab{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 112px 0;
    }
    .custom{
        display: flex;    
        flex-direction: column;
        height: auto;
        width: 80%;
        h4{
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 24px;
            text-align: center;
        }
        p{
            font-size: 18px;
            font-weight: 300;
            margin-top: 10%;
        }
    }
    .box1{
        width: 90%;
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .box2{
        display: none;
        grid-column: span 2;
        grid-row: span 1;
    }
    .box3{
        margin-top: 30px;
        display: block;
        width: 90%;
        .line{
            display: none;
            align-self: flex-end;
            margin-right: 40px;
        }
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .box4{
        margin-top: 30px;
        width: 90%;
        display: block;
        flex-direction: column;
        .content{
            img{
                width: 100%;
                object-fit: contain;
            }
            .box-img{
                width: 100%;
                object-fit: contain;
            }
        }
        .line{
            align-self: flex-end;
            display: none;
        }
    }
    .box5{
        margin-top: 30px;
        margin-left: 0px;
        width: 90%;
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #how{
    background: #fff;
    height: auto;
    width: 100%;
    padding: 80px 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Raleway', sans-serif;
    font-size: 16px;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .tab{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 112px 0;
    }
    .custom{
        display: flex;    
        flex-direction: column;
        height: auto;
        width: 80%;
        h4{
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 24px;
            text-align: center;
        }
        p{
            font-size: 18px;
            font-weight: 300;
            margin-top: 10%;
            text-align: center;
        }
    }
    .box1{
        width: 90%;
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .box2{
        display: none;
        grid-column: span 2;
        grid-row: span 1;
    }
    .box3{
        margin-top: 30px;
        display: block;
        width: 90%;
        .line{
            display: none;
            align-self: flex-end;
            margin-right: 40px;
        }
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .box4{
        margin-top: 30px;
        width: 90%;
        display: block;
        flex-direction: column;
        .content{
            img{
                width: 100%;
            object-fit: contain;
            }
            .box-img{
                width: 100%;
            object-fit: contain;
            }
        }
        .line{
            align-self: flex-end;
            display: none;
        }
    }
    .box5{
        margin-top: 30px;
        margin-left: 0px;
        width: 90%;
        img{
            width: 100%;
            object-fit: contain;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {
    #how{
    height: auto;
    .tab{
        padding-bottom: 0px;
    }
    .custom{
        display: grid;    
        grid-template-columns: repeat(4, 200px);
        grid-template-rows: repeat(5, 380px);
        height: auto;
        width: 100%;
    }
    .box1{
        grid-column: span 2;
        grid-row: span 2;
    }
    .box2{
        grid-column: span 2;
        grid-row: span 1;
    }
    .box3{
        display: flex;
        grid-column: span 2;
        grid-row: span 1;
        .line{
            align-self: flex-end;
            margin-right: 40px;
        }
        img{
            height: 276px;
        }
    }
    .box4{
        grid-column: span 2;
        grid-row: span 3;
        display: flex;
        flex-direction: column;
        .content{
            img{
                height: 276px;
                width: 372px;
            }
            .box-img{
                height: 276px;
                width: 239px;
            }
        }
        .line{
            align-self: flex-end;
        }
    }
    .box5{
        margin-top: 0;
        padding-top: 300px;
        margin-left: 80px;
        grid-column: span 2;
        grid-row: span 2;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}
</style>